import referralAccept from 'request/studio-id/referral-accept'

export default function FloatPanel({ studio }) {
  const t = useI18n()
  const { user } = useCurrent()
  const { open } = usePanel()

  const onReferralAccept = async() => {
    mkt.referralClick({ studioId: studio.id })
    if (!user) return open('auth')
    try {
      await referralAccept()
      $alert(t('page:referralCode.hero.success'))
      mkt.referralSuccess({ studioId: studio.id })
    } catch (error) {
      if (error.code !== 'referral.noValidPhone') throw error
      open('phoneUpdate')
    }
  }

  return (
    <div className='pt-4 pb-8 px-12 w-[20rem] bg-white shadow-lg rounded-md mx-auto'>
      <div className='border-[1px] rounded-full border-gray-200 w-28 h-28 mb-8 mt-4 mx-auto'>
        <C.Image
          src={ studio.logoUrl }
          className='pt-[100%] rounded-full'
        />
      </div>
      <div className='text-xl font-bold text-center'>
        <div className='pb-2'>{studio.name}</div>
        <div>{t('page:referralCode.hero.invite')}</div>
      </div>
      <div className='my-6 pt-[1px] bg-black bg-opacity-10' />
      <div className='flex justify-center'>
        <ul className='font-light list-disc list-inside inline-block'>
          {
            t('page:referralCode.hero.notes').map(note => <li key={ note }>{note}</li>)
          }
        </ul>
      </div>
      <div className='mt-6' >
        <C.Button
          uid='referralCode.receive'
          onClick={ onReferralAccept }
          fullWidth
        >
          {t('page:referralCode.hero.button')}
        </C.Button>
      </div>
    </div>
  )
}
